module.exports = __webpack_public_path__ + "static/media/twitter.96f5da61.svg";